import {getFirstQuestionListThunk, getChatHistoryListByDateThunk, getDocumentListThunk, deleteDocumentThunk, uploadDocFileToAnalyzeThunk, triggerFormAutomateThunk, triggerMeetAutomateThunk, getNotificationThunk, generateFromSurveyLinksThunk, shareFormSurveyLinkThunk} from './thunk';
import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
const initialMessage = {
    sender: 'bot',
    content: 'Hello, how can I help you?',
    sqlQuery: '',
    firstMessage: 'yes',
    isForecastable: null,
    forecastableFields: [],
}

const initialState = {
    fetchDocuments: true,
    documents: [],
    deleteDocumentVisibility: false,
    selectedDocument: null,
    chats: [initialMessage],
    history: [],
    errors: {},
    isMeetAgentModalOpen: false,
    isFormSurveyModalOpen: false,
    isNotificationModalOpen: false,
    notifications: [],
    newNotificationCount: 0,
    formSurveyLinks: {},
}

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setChats: (state, action) => {
            const payload = action.payload;
            state.chats = payload;
        },

        setHistoryChats: (state, action) => {
            const { date, data = [] } = action.payload;
            state[date] = data;
        },

        updateChats: (state, action) => {
            const { index, data } = action.payload;
            state.chats[index] = { ...state.chats[index], ...data };
        },

        updateHistoryChats: (state, action) => {
            const { index, date, data } = action.payload;
            state[date][index] = { ...state[date][index], ...data };
        },

        addNewChat: (state, action) => {
            const payload = action.payload;
            state.chats.push(payload);
        },

        addNewHistoryChat: (state, action) => {
            const { date, data } = action.payload;
            state[date].push(data);
        },

        resetChats: (state, action) => {
            state.chats = [initialMessage];
        },

        // Documents
        setFetchDocuments: (state, action) => {
            const payload = action.payload;
            state.fetchDocuments = payload
        },

        setSelectedDocument: (state, action) => {
            const payload = action.payload;
            state.selectedDocument = payload
        },

        setDeleteDocumentVisibility: (state, action) => {
            const payload = action.payload;
            state.deleteDocumentVisibility = payload
        },

        // Modal visibility
        setIsMeetAgentModalOpen: (state, action) => {
            state.isMeetAgentModalOpen = action.payload; // This will toggle the modal visibility
        },

        setIsFormSurveyModalOpen: (state, action) => {
            state.isFormSurveyModalOpen = action.payload; // This will toggle the modal visibility
        },


        setIsNotificationModalOpen: (state, action) => {
            state.isNotificationModalOpen = action.payload;
            if (action.payload) {
                state.newNotificationCount = 0;
            }
        },

        addNewNotification: (state, action) => {
            const newNotification = action.payload;
            state.notifications = [newNotification, ...state.notifications];

            if (!state.isNotificationModalOpen) {
                state.newNotificationCount += 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getFirstQuestionListThunk.fulfilled, (state, action) => {
            state.history = action.payload;
        });
        builder.addCase(getFirstQuestionListThunk.rejected, (state, action) => {
            state.errors.history = action.payload || null;
        });

        // Document List 
        builder.addCase(getDocumentListThunk.fulfilled, (state, action) => {
            state.documents = action.payload.documents;
        });
        builder.addCase(getDocumentListThunk.rejected, (state, action) => {
            state.errors.documents = action.payload || null;
        });

        // Document Delete
        builder.addCase(deleteDocumentThunk.fulfilled, (state, action) => {
            const docId = action?.meta?.arg?.doc_id;
            if (docId) {
                state.documents = state.documents.filter(document => document.id !== docId);
            }
        });
        builder.addCase(deleteDocumentThunk.rejected, (state, action) => {
            state.errors.deleteDocument = action.payload || null;
        });

        // Upload Document `uploadDocFileToAnalyzeThunk`

        builder.addCase(uploadDocFileToAnalyzeThunk.fulfilled, (state, action) => {
            const newData = {
                id: action.payload.id,
                filename: action.payload.filename,
                uploaded_at: new Date().toISOString().replace("T", " ").slice(0, 19),
            }
            state.documents = [...state.documents, newData];
        });
        builder.addCase(uploadDocFileToAnalyzeThunk.rejected, (state, action) => {
            state.errors.uploadDocument = action.payload || null;
        });

        builder.addCase(triggerFormAutomateThunk.fulfilled, (state, action) => {
            //   state.chats.push({
            //     sender: 'bot',
            //     content: action.payload.message || "Form automation triggered successfully.",
            //   });
        });
        builder.addCase(triggerFormAutomateThunk.rejected, (state, action) => {
            state.errors.formAutomate = action.payload || null;
        });

        builder.addCase(triggerMeetAutomateThunk.fulfilled, (state, action) => {
            //   state.chats.push({
            //     sender: 'bot',
            //     content: action.payload.message || "Meet automation triggered successfully.",
            //   });
        });
        builder.addCase(triggerMeetAutomateThunk.rejected, (state, action) => {
            state.errors.meetAutomate = action.payload || null;
        });
        builder.addCase(getNotificationThunk.fulfilled, (state, action) => {
            const rawData = action.payload?.data || [];
            state.notifications = rawData.map((item) => ({
                message: item.data.replace(/\\n/g, "\n").replace(/^"|"$/g, ""), // clean string
                time: dayjs(item.event_time).format("MMM D, YYYY [at] h:mm A"),
                event: item.event, // <-- Add this line to store event type

            }));
        });

        // Survey Link generation
        builder.addCase(generateFromSurveyLinksThunk.rejected, (state, action) => {
            state.formSurveyLinks = {}
        })

         builder.addCase(generateFromSurveyLinksThunk.fulfilled, (state, action) => {
            console.log("Survey Data -> ", action.payload.data);
            state.isFormSurveyModalOpen = true;
            state.formSurveyLinks = action.payload.data;
        })

        // Share survey links
        builder.addCase(shareFormSurveyLinkThunk.rejected, (state, action) => {
            state.errors.shareFormLinks = action.payload
        })

         builder.addCase(shareFormSurveyLinkThunk.fulfilled, (state, action) => {
            state.isFormSurveyModalOpen = false;
            state.formSurveyLinks = {}
        })
    },
});

export const {
    setChats,
    setHistoryChats,
    updateChats,
    updateHistoryChats,
    addNewChat,
    addNewHistoryChat,
    resetChats,
    setFetchDocuments,
    setSelectedDocument,
    setDeleteDocumentVisibility,
    setIsMeetAgentModalOpen,
    setIsFormSurveyModalOpen,
    setIsNotificationModalOpen,
    addNewNotification,
} = chatSlice.actions;

export default chatSlice.reducer;
